module.exports = __webpack_public_path__ + "img/right-info-close.82608c70.png";